import React, { Component } from "react";
import { Auth } from "aws-amplify";
import VerifyEmail from "../components/VerifyEmail";
import ConfirmationDialog from "../components/Dialogs/ConfirmationDialog";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as authActions from "../redux/actions/authActions";

const requireAuthentication = (component, role) => {
  class AuthenticatedComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        startRender: false,
        emailVerified: null,
        gettingUserDetails: true
      };
    }
    async componentDidMount() {
      try {
        await this.getUserDetails(false);
      } catch (error) {
        console.log(error);
        try {
          await this.getUserDetails(true);
        } catch (e) {
          console.log(e);
          this.props.history.push("/");
        }
      }
    }

    getUserDetails = async byPassCache => {
      let user = await Auth.currentAuthenticatedUser({
        bypassCache: byPassCache //if true you are manually getting the current authenticated user from cognito not from cache
      });
      console.log("session validity: " + user.getSignInUserSession().isValid());
      this.setState({ user });
      user.attributes.role = user.attributes["custom:role"];
      user.attributes.token = user
        .getSignInUserSession()
        .getAccessToken().jwtToken;
      let userAttributes = user.attributes;
      localStorage.setItem("user", JSON.stringify(userAttributes));
      let userRole = user.attributes.role;
      if (userRole !== role) {
        //redirect to access denied
      } else if (userRole === role) {
        let { email_verified } = user.attributes;
        if (!email_verified) {
          //try getting the email status from cognito itself

          let user = await Auth.currentAuthenticatedUser({
            bypassCache: true //if true you are manually getting the current authenticated user from cognito not from cache
          });
          email_verified = user.attributes.email_verified;
          if (!email_verified) {
            console.log("email is not verified");
            this.props.authActions.setUser(user.attributes, true, false);
            this.setState({
              startRender: true,
              emailVerified: false,
              gettingUserDetails: false
            });
          } else {
            console.log("email is verified");
            this.props.authActions.setUser(user.attributes, true, true);
            this.setState({
              startRender: true,
              emailVerified: true,
              gettingUserDetails: false
            });
          }
        } else {
          console.log("email is verified");
          this.props.authActions.setUser(user.attributes, true, true);
          this.setState({
            startRender: true,
            emailVerified: true,
            gettingUserDetails: false
          });
        }
      }
    };

    render() {
      if (this.state.startRender) {
        if (this.state.startRender && !this.state.emailVerified) {
          //show email verification screen
          return <VerifyEmail {...this.props} />;
        } else {
          let Component = component;
          return (
            <React.Fragment>
              <Component {...this.props} />
              <ConfirmationDialog />
            </React.Fragment>
          );
        }
      } else {
        return null;
      }
    }
  }
  const mapDispatchToProps = dispatch => {
    return {
      authActions: bindActionCreators(authActions, dispatch)
    };
  };
  return connect(
    null,
    mapDispatchToProps
  )(AuthenticatedComponent);
};

export default requireAuthentication;
